<template>
  <div>
    <list
      ref="list"
      unit="访客"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.list"
      @reset-query="$emit('reset-select')"
      :reRowClick="true"      
      :get-row-click-func="myRowClick"
      :pageSizes="[10, 20, 30, 40, 100, 1000]"
      show-summary  
      :summary-method="getSummaries"
    >
    <!-- condition="row.Status==0 || row.Status==1" -->
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="客户名称">
          <!-- <el-input
            v-model="params.CustomerName"
            @focus="addUnit"
            size="mini"
            readonly
            placeholder="请选择"
          ></el-input> -->
          <customer @restaurants="setSupplier" :state="params.CustomerName" />
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input
            size="mini"
            clearable
            v-model="params.DocNo"
            placeholder="请输入单据编号"
          />
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input
            size="mini"
            clearable
            v-model="params.OrderNo"
            placeholder="请输入订单编号"
          />
        </el-form-item>
        <!-- <el-form-item label="订单来源">
          <el-select size="mini" v-model="params.Source" placeholder="请选择" clearable>
            <el-option label="线上" :value="1"></el-option>
            <el-option label="线下" :value="2"></el-option>
          </el-select>
        </el-form-item>-->
        <!-- <el-form-item label="交货方式">
          <el-select size="mini" v-model="params.FreightMode" placeholder="请选择" clearable>
            <el-option label="异地配送" :value="1"></el-option>
            <el-option label="本地配送" :value="2"></el-option>
            <el-option label="自提" :value="3"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="单据状态">
          <el-select
            size="mini"
            v-model="params.Status"
            placeholder="请选择"
            clearable
          >
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库状态">
          <el-select
            size="mini"
            v-model="params.OutStatus"
            placeholder="请选择"
            clearable
          >
            <el-option label="未出库" :value="0"></el-option>
            <el-option label="部分出库" :value="1"></el-option>
            <el-option label="已出库" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="物流状态">
          <el-input size="mini" clearable v-model="params.GoodsName" placeholder="请输入物流状态" />
        </el-form-item>-->
        <!-- <el-form-item label="开票状态">
          <el-select
            size="mini"
            v-model="params.InvoiceStatus"
            placeholder="请选择"
            clearable
          >
            <el-option label="未完成" :value="1"></el-option>
            <el-option label="已完成" :value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="下单来源">
          <el-select
            size="mini"
            v-model="params.Source"
            placeholder="请选择"
            clearable
          >
            <el-option label="自主下单" :value="0"></el-option>
            <el-option label="代客下单" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款状态">
          <el-select
            size="mini"
            v-model="params.ReceiptStatus"
            multiple
            placeholder="请选择"
            clearable
          >
            <el-option label="未收款" :value="0"></el-option>
            <el-option label="挂账" :value="1"></el-option>
            <el-option label="已收款" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="物流单号">
          <el-input size="mini" clearable v-model="params.FreightNo" placeholder="请输入物流单号" />
        </el-form-item>-->
        <el-form-item label="单据日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin: 0 10px">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号" min-width="90px" />
        <el-table-column prop="DocDate" label="单据日期" min-width="100px">
          <template slot-scope="{ row }">{{
            row.DocDate.split(" ")[0]
          }}</template>
        </el-table-column>
        <el-table-column prop="Person" label="收货人" />
        <el-table-column prop="Phone" label="联系方式" 
          min-width="110px"/>
        <el-table-column prop="Source" label="来源">
          <template slot-scope="{ row }">{{
            row.Source == 0 ? "自主下单" : "代客下单"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="CustomerName"
          label="客户名称"
          min-width="230px"
        />
        <el-table-column prop="Amount" label="销货金额">
          <template slot-scope="{ row }">
            {{ row.Amount }}
          </template>
        </el-table-column>
        <el-table-column prop="OrderNo" label="订单编号" min-width="80px" />
        <el-table-column prop="ClerkName" label="业务员" />
        <el-table-column prop="Status" label="单据状态">
          <template slot-scope="{ row }">
            <span v-if="row.Status == 0">草稿</span>
            <span v-else-if="row.Status == 1">未生效</span>
            <span v-else-if="row.Status == 4">已取消</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="OutStatus" label="出库状态">
          <template slot-scope="{ row }">
            <span v-if="row.OutStatus == 0">未出库</span>
            <span v-else-if="row.OutStatus == 1">部分出库</span>
            <span v-else>已出库</span>
          </template>
        </el-table-column>
        <el-table-column prop="RefundStatus" label="退货状态">
          <template slot-scope="{ row }">
            <span v-if="row.RefundStatus == 1">退款待审</span>
            <span v-else-if="row.RefundStatus == 2">客户取消</span>
            <span v-else-if="row.RefundStatus == 3">同意退款</span>
            <span v-else-if="row.RefundStatus == 4">拒绝退款</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="ReceiptStatus" label="收款状态">
          <template slot-scope="{ row }">
            <span v-if="row.ReceiptStatus == 0">未收款</span>
            <span v-else-if="row.ReceiptStatus == 1">挂账</span>
            <span v-else>已收款</span>
          </template>
        </el-table-column>
        <el-table-column prop="InvoiceStatus" label="开票状态">
          <template slot-scope="{ row }">
            <span v-if="row.InvoiceStatus == 0">未完成</span>
            <span v-else>已完成</span>
          </template>
        </el-table-column>
        <el-table-column prop="PayType" label="支付方式">
          <template slot-scope="{ row }">
            <span v-if="row.PayType == 1">余额支付</span>
              <span v-else-if="row.PayType == 2">信用支付</span>
              <span v-else-if="row.PayType == 3">微信支付</span>
              <span v-else>其他</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <unit-dialog
      ref="unitDialog"
      in-dialog
      selectable
      @select="setUnit"
      title="客户列表"
      :typeList="[1, 2]"
    />
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import unitDialog from "@/components/basicinfo/basic/logistics/listDialog";

export default {
  mixins: [listMixin],
  components: { list, unitDialog, customer },
  data() {
    return {
      api: require("@/api/sale/saDoc").default,
      params: {
        DocNo: "",
        OrderNo: "",
        Score: null,
        ScoreText: "",
        AddTime: "",
        Status: null,
        OutStatus: null,
        DocDateStart: "",
        FreightMode: null,
        FreightNo: "",
        InvoiceStatus: null,
        ReceiptStatus: null,
        DocDateEnd: "",
        CustomerId: null,
        CustomerName: "",
        // CustomerType: 1
      },
    };
  },
  methods: { 
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 7 ) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return  Number(Number(Number(prev) + value).toFixed(2));
              } else {
                return Number(Number(prev).toFixed(2));
              }
            }, 0);
            sums[index] = sums[index];
          }
          return;
        }
      });
      return sums;
    },
    setSupplier(data) {
      this.params.CustomerId = data.TradeUnitId;
      this.params.CustomerName = data.TradeUnitName;
      // this.params.CustomerType = data.TradeUnitType;
    },
    myRowClick(row, column, e) {
      this.$emit("loading");
      this.api.info(row.DocId).then((res) => {
        this.$emit("setDetails", res.Data.Goods, row);
        this.$emit("loading");
      });
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
      });
    },
    setUnit(e) {
      this.params.CustomerId = e.Id;
      this.params.CustomerName = e.Name;
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.DocExport(this.params).then(() => {
        loading.close();
      });
    },
  },
};
</script>